export default __webpack_public_path__ + "static/media/taiwo.f8cc24ed.jpg";